export default "__VITE_ASSET__DSm2M66t__"